import { c as _c } from "react/compiler-runtime";
import { MarkdownRenderer } from '@src/components/sco/MarkdownRenderer';
import React from 'react';

/**
 * Every message body on the desk goes through this. A member writes these bodies and the reader is a
 * signed-in admin, so the renderer runs in `safe` mode: no raw HTML, no remote images, and only
 * http, https, and mailto links. Do not render a desk body with `MarkdownRenderer` directly.
 */
export function CrmMarkdown(props) {
  const $ = _c(2);
  let t0;
  if ($[0] !== props.children) {
    t0 = <MarkdownRenderer safe={true} baseFontSize="1em" injectParagraphsIfBreaksNotPresent={true} preset="chat-message">{props.children}</MarkdownRenderer>;
    $[0] = props.children;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return t0;
}